export default "__VITE_ASSET__rfPqWhc0__"